import MixinResize from '../mixin-resize'
import MixinScroll from '../mixin-scroll'
import AppPageLinks from '../app-page-links'
import AppBook from '../app-book'
import content from '../../content'

export default
{
    mixins: [
        MixinResize,
        MixinScroll
    ],

    components: {
        AppPageLinks,
        AppBook
    },

    data() {
        return {
            mail: content.mailto
        }
    },

    methods:
    {
        onResized()
        {
            // Hide warning
        },

        onScroll()
        {
            // Hide warning
        }
    }
}
